import { render, staticRenderFns } from "./imgSwiper.vue?vue&type=template&id=32cb9e31&scoped=true&"
import script from "./imgSwiper.vue?vue&type=script&lang=js&"
export * from "./imgSwiper.vue?vue&type=script&lang=js&"
import style0 from "./imgSwiper.vue?vue&type=style&index=0&id=32cb9e31&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32cb9e31",
  null
  
)

export default component.exports